import * as ko from 'knockout'
import template from './dog.finisher.tpl.html'
import { DogFinisherViewModel, Params } from './DogFinisherViewModel'

if (!ko.components.isRegistered('dog-finisher')) {
  ko.components.register('dog-finisher', {
    viewModel: {
      createViewModel: (params: Params) => {
        const viewModel = new DogFinisherViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
